export default "__VITE_ASSET__BDVOCAX6__"